import styled from 'styled-components';

export const ArticleText = styled.div<{ appContent: boolean }>`
  max-width: ${({ appContent }) => (appContent ? 'none' : '30em')};
  margin-left: auto;
  margin-right: auto;
`;
